import { useCall } from "@/hooks/useCall/useCall";
import { useGetCustomSummaryResults } from "@/hooks/useGetCustomSummaryResults";
import { Flex } from "@aircall/tractor";
import { Loader } from "@dashboard/library";
import { CustomSummaryResultsForm } from "../CustomSummaryForm/CustomSummaryResultsForm";
import { SectionHeader } from "../SectionHeader";
import { SectionLayout } from "../SectionLayout";

export function SectionCustomSummary() {
  const { call } = useCall();
  const callId = call?.id ?? undefined;
  const { customSummaryResult, loading } = useGetCustomSummaryResults(callId);

  if (!callId) {
    return null;
  }

  if (loading) {
    return (
      <Flex h="70px" w="100%" alignItems="center" justifyContent="center">
        <Loader />
      </Flex>
    );
  }

  if (!customSummaryResult) {
    return null;
  }

  const title = customSummaryResult.customSummary.name;

  return (
    <SectionLayout data-test="playbook-section">
      <SectionHeader beta>{title}</SectionHeader>

      <Flex
        bg="surface-background"
        borderRadius="sm"
        p="s"
        flexDirection="column"
      >
        <CustomSummaryResultsForm
          customSummaryResultId={customSummaryResult.id}
          templateResults={customSummaryResult.templateResults}
          templates={customSummaryResult.customSummary.templates}
        />
      </Flex>
    </SectionLayout>
  );
}
